import { render, staticRenderFns } from "./OnlineStoreGroupBase.vue?vue&type=template&id=5d2dc42e&"
import script from "./OnlineStoreGroupBase.vue?vue&type=script&lang=js&"
export * from "./OnlineStoreGroupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports